export interface InfiniteTalkPresetPerson {
  id: string;
  name: string;
  imageUrl: string;
  description: string;
}

/**
 * Synthetic people created for EasyShot. Keeping these IDs separate from
 * uploaded avatar IDs lets the render pipeline resolve only known assets.
 */
export const INFINITETALK_PRESET_PEOPLE: InfiniteTalkPresetPerson[] = [
  {
    id: "itp_nora",
    name: "Nora",
    imageUrl: "/infinitetalk/presets/nora.png",
    description: "Warm, approachable presenter",
  },
  {
    id: "itp_daniel",
    name: "Daniel",
    imageUrl: "/infinitetalk/presets/daniel.png",
    description: "Confident product presenter",
  },
  {
    id: "itp_mei",
    name: "Mei",
    imageUrl: "/infinitetalk/presets/mei.png",
    description: "Friendly lifestyle presenter",
  },
];

export function findInfiniteTalkPresetPerson(id: string) {
  return INFINITETALK_PRESET_PEOPLE.find((person) => person.id === id);
}
